import $ from "jquery";

export function collapseSearchResult(localStoragePreix) {

    let collapseButton = $('#collapse-button');

    // Changed search results to collapsed on page load if the visitor has previously selected it to be collapsed 
    if (typeof (Storage) !== "undefined" && localStorage.getItem(localStoragePreix + "-collapsedMode") === "collapsed") {
        switchedCollapseMode(localStoragePreix, collapseButton);
    }
    
    collapseButton.click(function () {

        switchedCollapseMode(localStoragePreix, collapseButton);

        // Prevent button from reloading the page
        return false;
    });
}

function switchedCollapseMode(localStoragePreix, collapseButton) {
    let searchResults = $('#search-results');

    // Replace css classes to switch between expanded and collapsed mode
    searchResults.toggleClass("expanded");
    searchResults.toggleClass("collapsed");

    // Change class on button to switch icon
    let collapseButtonWrapper = $('.collapse-button-wrapper');
    collapseButtonWrapper.toggleClass("expanded");
    collapseButtonWrapper.toggleClass("collapsed");

    // Change text depending on collapsed state
    if (searchResults.hasClass('collapsed')) {
        collapseButton.text('visa träffar expanderade');

        // Save to local storage
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(localStoragePreix + "-collapsedMode", "collapsed");
        }
    }
    else {
        collapseButton.text('visa träffar minimerade');

        // Save to local storage
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(localStoragePreix + "-collapsedMode", "expanded");
        }
    }
}